import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { getSelectedPartyTicket } from "./utils";

const PartyPrice = props => {
  const [fee, setFee] = useState("Loading");
  const calculateFee = () => {
    const plan = getSelectedPartyTicket(props.program, props.selected);
    setFee(parseFloat(plan.ticket_price).toFixed(2));
    props.itemAmount(parseFloat(plan.ticket_price).toFixed(2));
  };
  useEffect(() => {
    calculateFee();
  }, []);
  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 500,
          fontSize: "14px"
        }}
      >
        Party Fee - Payable Now.
      </p>
      <span style={{ fontWeight: 500, fontSize: "14px" }}>${fee}</span>
    </li>
  );
};

PartyPrice.propTypes = {
  program: PropTypes.shape({
    tickets: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired
};

export default PartyPrice;
